(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class SixthHeaderElement extends HTMLElement {
    connectedCallback() {
      this.bindToggles();
      this.bindOutsideClicks();
      this.bindEscape();
      this.bindDropdownKeys();
    }

    /* The Shop menu could only be walked with Tab, and Tab past the last
       item left it hanging open behind you with focus already three items
       down the page. Arrow keys are what people try in a menu like this. */
    bindDropdownKeys() {
      const item = this.querySelector('.sixth-header__nav-item--has-dropdown');
      const trigger = this.querySelector('[data-sixth-toggle="shop-dropdown"]');
      if (!item || !trigger) return;

      // Down from the closed trigger opens the menu and lands on item one.
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        this.openShopDropdown();
        const links = this.getDropdownLinks();
        if (links.length) links[0].focus();
      });

      item.addEventListener('keydown', (event) => {
        const links = this.getDropdownLinks();
        if (links.length === 0) return;
        const index = links.indexOf(document.activeElement);
        if (index === -1) return;
        let next = null;
        if (event.key === 'ArrowDown') next = links[(index + 1) % links.length];
        else if (event.key === 'ArrowUp') next = links[(index - 1 + links.length) % links.length];
        else if (event.key === 'Home') next = links[0];
        else if (event.key === 'End') next = links[links.length - 1];
        if (!next) return;
        event.preventDefault();
        next.focus();
      });

      // Close once focus has actually left the whole item. The frame delay
      // matters: during focusout, activeElement is still <body>, so testing
      // it immediately would close the menu on every internal move. The
      // trigger lives inside `item` too, so clicking it to toggle does not
      // trip this.
      item.addEventListener('focusout', () => {
        window.requestAnimationFrame(() => {
          if (!item.contains(document.activeElement)) {
            this.closeShopDropdown();
          }
        });
      });
    }

    getDropdownLinks() {
      const dropdown = this.querySelector('#sixth-shop-dropdown');
      if (!dropdown || dropdown.hasAttribute('hidden')) return [];
      return Array.from(dropdown.querySelectorAll('a[href]'));
    }

    openShopDropdown() {
      const dropdown = this.querySelector('#sixth-shop-dropdown');
      const trigger = this.querySelector('[data-sixth-toggle="shop-dropdown"]');
      if (!dropdown) return;
      dropdown.removeAttribute('hidden');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    bindToggles() {
      this.querySelectorAll('[data-sixth-toggle]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          const target = trigger.getAttribute('data-sixth-toggle');
          if (target === 'mobile-panel') {
            this.toggleMobilePanel();
          } else if (target === 'shop-dropdown') {
            this.toggleShopDropdown(trigger);
          }
        });
      });
    }

    bindOutsideClicks() {
      document.addEventListener('click', (event) => {
        const dropdown = this.querySelector('#sixth-shop-dropdown');
        if (!dropdown || dropdown.hasAttribute('hidden')) return;
        if (!this.contains(event.target)) {
          this.closeShopDropdown();
        }
      });
    }

    bindEscape() {
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          // Escape must hand focus back to the control that opened the menu,
          // otherwise focus is left on a now-hidden element and the next Tab
          // restarts from the top of the document.
          this.closeShopDropdown({ restoreFocus: true });
          this.closeMobilePanel();
          return;
        }

        if (event.key !== 'Tab') return;
        const focusables = this.getMobilePanelFocusables();
        if (focusables.length === 0) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    toggleMobilePanel() {
      const panel = this.querySelector('#sixth-mobile-panel');
      const trigger = this.querySelector('[data-sixth-toggle="mobile-panel"]');
      if (!panel) return;
      const isOpen = !panel.hasAttribute('hidden');
      if (isOpen) {
        this.closeMobilePanel();
      } else {
        this.mobilePanelTrigger = trigger;
        panel.removeAttribute('hidden');
        panel.setAttribute('aria-hidden', 'false');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        this.setBackgroundInert(true);
        const closeButton = panel.querySelector('.sixth-header__mobile-close');
        if (closeButton) closeButton.focus();
      }
    }

    /* The panel declares aria-modal="true", but the Tab trap only constrains
       the keyboard: without this, a screen reader's own navigation still
       reaches the page behind it, so the modal claim was not true. `inert`
       removes the background from the accessibility tree and from hit
       testing. Unsupported browsers simply ignore the attribute and fall
       back to the existing Tab trap. */
    setBackgroundInert(on) {
      const bar = this.querySelector('.sixth-header__bar');
      const announcement = this.querySelector('.sixth-header__announcement');
      const outside = [
        bar,
        announcement,
        document.getElementById('main-content'),
        document.querySelector('.sixth-footer'),
      ];
      outside.forEach((el) => {
        if (!el) return;
        if (on) {
          el.setAttribute('inert', '');
        } else {
          el.removeAttribute('inert');
        }
      });
    }

    closeMobilePanel() {
      const panel = this.querySelector('#sixth-mobile-panel');
      const trigger = this.querySelector('[data-sixth-toggle="mobile-panel"]');
      if (!panel) return;
      panel.setAttribute('hidden', '');
      panel.setAttribute('aria-hidden', 'true');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      // Clear inert before restoring focus: the hamburger lives inside the
      // inerted bar, and an inert element cannot take focus.
      this.setBackgroundInert(false);
      if (this.mobilePanelTrigger && document.contains(this.mobilePanelTrigger)) {
        this.mobilePanelTrigger.focus();
      }
    }

    getMobilePanelFocusables() {
      const panel = this.querySelector('#sixth-mobile-panel');
      if (!panel || panel.hasAttribute('hidden')) return [];
      return Array.from(panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    }

    toggleShopDropdown(trigger) {
      const dropdown = this.querySelector('#sixth-shop-dropdown');
      if (!dropdown) return;
      const isOpen = !dropdown.hasAttribute('hidden');
      if (isOpen) {
        this.closeShopDropdown();
      } else {
        this.openShopDropdown();
      }
    }

    closeShopDropdown(options) {
      const dropdown = this.querySelector('#sixth-shop-dropdown');
      const trigger = this.querySelector('[data-sixth-toggle="shop-dropdown"]');
      if (!dropdown) return;
      const wasOpen = !dropdown.hasAttribute('hidden');
      dropdown.setAttribute('hidden', '');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      // Only pull focus when this actually closed something, so a stray
      // Escape elsewhere on the page doesn't yank focus into the header.
      if (wasOpen && options && options.restoreFocus && trigger) {
        trigger.focus();
      }
    }
  }

  if (!customElements.get('sixth-header-element')) {
    customElements.define('sixth-header-element', SixthHeaderElement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sixth-product-main')) {
    customElements.define('sixth-product-main', class SixthProductMain extends HTMLElement {
      constructor() {
        super();
        this.variants = [];
        this.images = [];
        this.activeIndex = 0;
        this.cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      }

      connectedCallback() {
        const dataNode = this.querySelector('[data-product-json]');
        if (dataNode) {
          try {
            const parsed = JSON.parse(dataNode.textContent);
            this.variants = parsed.variants || [];
          } catch (err) {
            this.variants = [];
          }
        }

        const lightboxNode = this.querySelector('[data-lightbox-sources]');
        if (lightboxNode) {
          try {
            this.images = JSON.parse(lightboxNode.textContent);
          } catch (err) {
            this.images = [];
          }
        }

        this.bindGallery();
        this.bindOptions();
        this.bindQuantity();
        this.bindForm();
        this.bindLightbox();
      }

      bindGallery() {
        const stage = this.querySelector('[data-stage]');
        if (!stage) return;
        const slides = Array.from(this.querySelectorAll('[data-stage-slide]'));
        const thumbs = Array.from(this.querySelectorAll('[data-thumb]'));

        const setActive = (index) => {
          if (index < 0) index = slides.length - 1;
          if (index >= slides.length) index = 0;
          this.activeIndex = index;
          slides.forEach((slide, i) => {
            const active = i === index;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
            slide.setAttribute('tabindex', active ? '0' : '-1');
          });
          thumbs.forEach((thumb, i) => {
            const active = i === index;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        };

        thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const index = parseInt(thumb.dataset.index, 10) || 0;
            setActive(index);
          });
        });

        slides.forEach((slide) => {
          slide.addEventListener('click', () => {
            if (slide.classList.contains('is-active')) {
              this.openLightbox(this.activeIndex);
            }
          });
        });

        stage.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            setActive(this.activeIndex + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            setActive(this.activeIndex - 1);
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.openLightbox(this.activeIndex);
          }
        });

        this.setStage = setActive;
      }

      bindOptions() {
        const inputs = Array.from(this.querySelectorAll('[data-option-input]'));
        if (inputs.length === 0) return;

        inputs.forEach((input) => {
          input.addEventListener('change', () => this.updateVariant());
        });
      }

      bindQuantity() {
        const input = this.querySelector('[data-qty-input]');
        const dec = this.querySelector('[data-qty-decrement]');
        const inc = this.querySelector('[data-qty-increment]');
        if (!input) return;

        if (dec) {
          dec.addEventListener('click', () => {
            const next = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
            input.value = next;
          });
        }
        if (inc) {
          inc.addEventListener('click', () => {
            const next = (parseInt(input.value, 10) || 1) + 1;
            input.value = next;
          });
        }
        input.addEventListener('blur', () => {
          if (!input.value || parseInt(input.value, 10) < 1) input.value = 1;
        });
      }

      updateVariant() {
        const optionGroups = Array.from(this.querySelectorAll('[data-option]'));
        const selected = optionGroups.map((group) => {
          const checked = group.querySelector('input[data-option-input]:checked');
          const display = group.querySelector('[data-option-value-display]');
          if (checked && display) display.textContent = checked.value;
          return checked ? checked.value : null;
        });

        const match = this.variants.find((variant) => {
          return variant.options.every((opt, i) => opt === selected[i]);
        });

        const idInput = this.querySelector('[data-variant-id]');
        const priceEl = this.querySelector('[data-price]');
        const atc = this.querySelector('[data-atc]');
        const atcLabel = this.querySelector('[data-atc-label]');

        if (match) {
          if (idInput) {
            idInput.value = match.id;
            idInput.removeAttribute('disabled');
          }
          if (priceEl) priceEl.textContent = match.price_formatted;
          if (typeof this.setStage === 'function') {
            const imageIndex = Number.parseInt(match.image_index, 10);
            if (!Number.isNaN(imageIndex)) this.setStage(imageIndex);
          }
          if (atc) {
            if (match.available) {
              atc.removeAttribute('disabled');
              atc.removeAttribute('aria-disabled');
              if (atcLabel) atcLabel.textContent = 'Add to cart';
            } else {
              atc.setAttribute('disabled', '');
              atc.setAttribute('aria-disabled', 'true');
              if (atcLabel) atcLabel.textContent = 'Sold out';
            }
          }
        } else if (atc) {
          atc.setAttribute('disabled', '');
          atc.setAttribute('aria-disabled', 'true');
          if (atcLabel) atcLabel.textContent = 'Unavailable';
        }
      }

      bindForm() {
        const form = this.querySelector('form#sixth-product-form') || this.querySelector('form');
        if (!form) return;

        const atc = this.querySelector('[data-atc]');
        const atcLabel = this.querySelector('[data-atc-label]');
        const error = this.querySelector('[data-atc-error]');

        form.addEventListener('submit', async (event) => {
          if (!window.fetch) return;
          event.preventDefault();
          if (atc && atc.hasAttribute('disabled')) return;

          const formData = new FormData(form);
          formData.append('sections', 'cart-drawer,cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);

          const previousLabel = atcLabel ? atcLabel.textContent : '';
          if (atcLabel) atcLabel.textContent = 'Adding...';
          if (atc) atc.setAttribute('disabled', '');
          if (error) {
            error.hidden = true;
            error.textContent = '';
          }

          try {
            const response = await fetch(this.cartAddUrl, {
              method: 'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData,
            });
            const data = await response.json();

            if (!response.ok) {
              const message = data.description || data.message || 'Something went sideways. Try again.';
              if (error) {
                error.textContent = message.toLowerCase();
                error.hidden = false;
              }
              if (atcLabel) atcLabel.textContent = previousLabel;
              if (atc) atc.removeAttribute('disabled');
              return;
            }

            if (data.sections) {
              this.replaceCartSections(data.sections);
            }
            this.syncHeaderCartCount();

            this.dispatchEvent(new CustomEvent('sixth:cart:added', {
              bubbles: true,
              detail: { items: data.items || [data] },
            }));

            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              drawer.open();
            } else if (drawer && drawer.classList) {
              drawer.classList.add('active', 'animate', 'is-empty');
              const opener = document.querySelector('[aria-controls="CartDrawer"]');
              if (opener) opener.click();
            }

            if (atcLabel) atcLabel.textContent = 'Added';
            setTimeout(() => {
              if (atcLabel) atcLabel.textContent = previousLabel || 'Add to cart';
              if (atc) atc.removeAttribute('disabled');
            }, 1200);
          } catch (err) {
            if (error) {
              error.textContent = 'connection dropped. try again.';
              error.hidden = false;
            }
            if (atcLabel) atcLabel.textContent = previousLabel;
            if (atc) atc.removeAttribute('disabled');
          }
        });
      }

      replaceCartSections(sections) {
        Object.keys(sections).forEach((key) => {
          const container = document.getElementById(key) || document.querySelector(`[id*="${key}"]`);
          if (!container) return;
          const parser = new DOMParser();
          const doc = parser.parseFromString(sections[key], 'text/html');
          const incoming = doc.querySelector(`#shopify-section-${key}`);
          if (incoming) {
            container.innerHTML = incoming.innerHTML;
          } else {
            container.innerHTML = sections[key];
          }
        });
      }

      async syncHeaderCartCount() {
        try {
          const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          const count = cart.item_count || 0;
          document.querySelectorAll('[data-sixth-cart-count]').forEach((el) => {
            el.textContent = count;
            if (count === 0) {
              el.setAttribute('hidden', '');
            } else {
              el.removeAttribute('hidden');
            }
          });
          document.querySelectorAll('.sixth-header__cart').forEach((el) => {
            el.setAttribute('aria-label', `Cart, ${count} item${count !== 1 ? 's' : ''}`);
          });
        } catch (err) {
          // Cart content is already added; the badge can catch up on the next page render.
        }
      }

      bindLightbox() {
        const lightbox = this.querySelector('[data-lightbox]');
        if (!lightbox || typeof lightbox.showModal !== 'function') return;
        const img = lightbox.querySelector('[data-lightbox-img]');
        const closeBtn = lightbox.querySelector('[data-lightbox-close]');
        const prevBtn = lightbox.querySelector('[data-lightbox-prev]');
        const nextBtn = lightbox.querySelector('[data-lightbox-next]');

        const setImage = (index) => {
          if (!this.images.length) return;
          if (index < 0) index = this.images.length - 1;
          if (index >= this.images.length) index = 0;
          this.activeIndex = index;
          if (img) {
            img.src = this.images[index].src;
            img.alt = this.images[index].alt || '';
          }
        };

        if (closeBtn) closeBtn.addEventListener('click', () => lightbox.close());
        if (prevBtn) prevBtn.addEventListener('click', () => setImage(this.activeIndex - 1));
        if (nextBtn) nextBtn.addEventListener('click', () => setImage(this.activeIndex + 1));

        lightbox.addEventListener('click', (event) => {
          if (event.target === lightbox) lightbox.close();
        });
        lightbox.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') setImage(this.activeIndex + 1);
          if (event.key === 'ArrowLeft') setImage(this.activeIndex - 1);
        });

        this.openLightbox = (index) => {
          if (this.getAttribute('data-enable-zoom') !== 'true') return;
          setImage(index);
          lightbox.showModal();
        };
      }

      openLightbox() {
        // Replaced inside bindLightbox when supported. No-op fallback.
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
